export default __webpack_public_path__ + "static/media/share-alt.b195a613.svg";